import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators, } from "@angular/forms";
import { AdminDataProvider } from '../../shared/providers/master-provider/admin-data.provider';
import { VisibilityModel } from '../../shared/models/visibility';
import { ToastClientService } from "../../../services/toast/toast-client.service";
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { VisibilityProvider } from '../../shared/providers/visibility.provider';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { Input } from '@angular/core';
@Component({
  selector: 'app-visibility-element-add',
  templateUrl: './visibility-element-add.component.html',
  styleUrls: ['./visibility-element-add.component.scss']
})
export class VisibilityElementAddComponent implements OnInit {

  @Input() model = new VisibilityModel;

  formGroup;
  templateImg: String;
  bannerImg: String;
  planogramImg: String;
  i: Number
  submitted: any;
  selectedChannels: any = [];
  finalChannelList: any = [];
  selectAll: Boolean = false;
  channels: any = [];

  elementTypes = [
    {
      id: 1,
      name: "POSM"
    },
    {
      id: 2,
      name: "Shelves"
    }
  ]

  constructor(
    public visibilityProvider: VisibilityProvider,
    public adminDataProvider: AdminDataProvider,
    private modalService: NgbModal,
    private fb: FormBuilder,
    private router: Router,
    private toast: ToastClientService,
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
  ) { }

  ngOnInit() {
    this.addVisibilityElement();
    this.getAllChannels();
  }


  addVisibilityElement() {
    this.formGroup = this.fb.group({
      program_id: 1,
      element_type: new FormControl("", [Validators.required]),
      posm_audit_type: new FormControl("", [Validators.required]),
      ml_class_name: new FormControl("", [Validators.required]),
      ml_threshold_percentage: new FormControl("", [Validators.required, Validators.pattern('^0*(?:[1-9][0-9]?|100)$')]),
      posm_image_template: new FormControl("", [Validators.required]),
      posm_image_banner: new FormControl("", [Validators.required]),
      image_planogram: new FormControl("", [Validators.required]),
    });
  }

  get f() {
    return this.formGroup.controls;
  }

  getAllChannels() {
    this.apiService.getHeaders(this.apiConfig.getAllChannel)
      .subscribe((res: any) => {
        this.channels = res.body.data.all_channels;
        this.channels.forEach(channel => {
          channel.isSelected = false;
        });
        this.selectedChannels = this.channels;
      }, err => {
        this.toast.Error('Error getting channels')
      })
  }

  uploadImg(i) {
    if (i == 1) {
      this.i = 1;
      document.getElementById('file1').click();
    } else if (i == 2) {
      this.i = 2;
      document.getElementById('file2').click();
    } else {
      this.i = 3;
      document.getElementById('file3').click();
    }
  }

  onUploadChange(evt: any) {
    const file = evt.target.files[0];

    if (file) {
      const reader = new FileReader();

      reader.onload = this.handleReaderLoaded.bind(this);
      reader.readAsBinaryString(file);
    }
  }

  handleReaderLoaded(e) {
    if (this.i == 1) {
      this.templateImg = 'data:image/png;base64,' + btoa(e.target.result)
    } else if (this.i == 2) {
      this.bannerImg = 'data:image/png;base64,' + btoa(e.target.result)
    } else if (this.i == 3) {
      this.planogramImg = 'data:image/png;base64,' + btoa(e.target.result)
    }
  }

  showChannelModal(targetModal) {
    this.modalService.open(targetModal, {
      centered: true,
      backdrop: 'static',
      size: 'lg',
    });
  }

  //handle channel checkbox
  checkboxAction(i) {
    this.selectedChannels[i].isSelected = !this.selectedChannels[i].isSelected;
  }

  // select/deselect all
  toggleAll() {
    this.selectAll = !this.selectAll;

    if (this.selectAll == true) {
      this.selectedChannels.forEach(channel => {
        channel.isSelected = true;
      });
    } else {
      this.selectedChannels.forEach(channel => {
        channel.isSelected = false;
      });
    }
  }

  getSelectedChannels() {
    this.finalChannelList = [];
    this.selectedChannels.forEach(channel => {
      if (channel.isSelected == true) {
        this.finalChannelList.push(channel.id);
      }
    });
  }

  closeChannelModal() {
    this.modalService.dismissAll();
  }

  onSubmitVisibility(formGroup: VisibilityModel) {
    this.getSelectedChannels();
    formGroup.channels = this.finalChannelList.toString();
    formGroup.posm_image_template = this.templateImg;
    formGroup.posm_image_banner = this.bannerImg;
    formGroup.image_planogram = this.planogramImg;
    console.log(formGroup);

    this.model = formGroup;
      // console.log(formData);
      this.visibilityProvider.addVisibility(this.model);
  }


}
